import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=priority'],
};
